"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowWrap = exports.RowsWrap = exports.styles = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styles = (_theme) => ({
    root: {
        height: '100%',
        color: 'black',
    },
    divider: {
        margin: '15px 0',
    },
    body2: {
        fontSize: 13,
    },
    body2bold: {
        extend: 'body2',
        fontWeight: 500,
    },
});
exports.styles = styles;
const RowWrap = styled_components_1.default.div `
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    color: black;
    text-align: left;
  `;
exports.RowWrap = RowWrap;
const RowsWrap = styled_components_1.default.div `
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
  `;
exports.RowsWrap = RowsWrap;
